;(function ($) {
  'use strict';

	$(document).ready(function() {
		close_alert();
	});

	function close_alert() {
		$('.alert__close').on('click',function(){
			$('.alert').slideUp('fast');
			// localStorage.setItem("alert-bar", "hide");

			// Setting the cookie for 1 day
			const d = new Date();
			var days_to_expire = 1;
			d.setTime(d.getTime() + (days_to_expire*24*60*60*1000));
			let expires = "expires="+ d.toUTCString();
			document.cookie =  "alert-bar=hide;" + expires + ";path=/";
		});
	}
})(jQuery);